import { FC, useState, useMemo } from 'react';
import { FlexBox } from '@brg/ui';
import { Designer, Lang, OpaUser } from '@brg/api';

import { IDesignerLight } from '../../../common';
import { DesignersGridNew } from '../../../components/grids';
import { NeutralLink } from 'shared/components/link/styles';
import { CreateLinkTo } from "../../../constants/linkTo";
import useQueryState from "../../../hooks/useQueryState";
import { DesignerCardNew } from 'shared/components/designerCard/designerCard';
import { computeDesigner } from 'shared/helpers/computeData';
import { CompetitionJuryCard } from '_competition/pages/CreateCompetitionPage/CompetitionJury';
import { ProfileUtils } from 'core';
import { getExpertTags } from 'shared/helpers/utils/TagsUtils';
import { CombinedEvents } from 'shared/helpers/projectEvents';

export interface TeachersTabProps {
    data: Designer[];
    isLoading?: boolean;
    showOpa?: boolean;
    showTags?: boolean;
    onDesignerClick?: (id: string) => void;
    isOpaCard?: boolean;
    pages?: number;
    noPagination?: boolean;
    inDetail?: boolean;
    language?: string;
    tooltip?: boolean;
    handlers?: CombinedEvents;
    isMe?: any;
    twoMobileColumns?: boolean;
    isMobileMoreVisible?: boolean;
}

const showAll = false;

/**
 * Грид с учителями
 * @param props
 * @constructor
 */
export const PeoplePageGrid: FC<TeachersTabProps> = (props) => {
    const { data, isLoading, showOpa, isOpaCard, inDetail, isMe, isMobileMoreVisible, twoMobileColumns, language, showTags , tooltip, ...handlers } = props;
    const [opaUsers] = useState<OpaUser[]>([]);

    const computeData: IDesignerLight[] = useMemo(
        () => data?.map((i) => computeDesigner(i)), [data])

        if (inDetail) {
            return (
                <FlexBox direction="column" directionMobile="column" gy={40} width="100%">
                    <DesignersGridNew isLoading={isLoading} mobileColumns={2} isOpaCard={isOpaCard} inDetailCard>
                        {data?.map((value) => {
                            const isExpert  = value?.rolesList?.includes("expertmoder");
                            const expertTags = isExpert ? getExpertTags(value?.tagsExpert) : [];
                            const showTags = isExpert && !!expertTags?.length;
                            return (
                                <CompetitionJuryCard 
                                    key={value?.designerId}
                                    avatar={ProfileUtils.getAvatarURLOrUndefined(value)}
                                    fullName={ProfileUtils.getFullNameString(value)}
                                    text={Lang(value?.about, language ?? 'ru')}
                                    tagsIds={expertTags}
                                    id={value?.designerId}
                                    href={CreateLinkTo.designerNew(value)}
                                    isShowcase
                                    showTags={showTags}
                                />
                            )
                        })}
                    </DesignersGridNew>
                </FlexBox>
            )
        }
    
    return (
        <FlexBox direction="column" directionMobile="column" gy={40} width="100%">
            <DesignersGridNew isLoading={isLoading} mobileColumns={2} isOpaCard={isOpaCard}>
                {computeData.map((value: IDesignerLight) => {
                    const opaUser = opaUsers.find((opaUser) => opaUser.accountId === value.identifier);

                    return (
                    //   <NeutralLink to={CreateLinkTo.designerNew(value)}>
                        
                    //@ts-ignore
                        <DesignerCardNew
                            showOpa={showOpa}
                            // onClick={onDesignerClick}
                            designer={value}
                            {...value}
                            {...handlers}
                            isMe={isMe}
                            isMobileMoreVisible={isMobileMoreVisible}
                            twoMobileColumns={twoMobileColumns}
                            key={value.identifier}
                            opaUser={opaUser}
                            isOpaCard={isOpaCard}
                            tooltip={tooltip}
                            withRating
                            href={CreateLinkTo.designerNew(value)}
                        />

                    );
                })}
            </DesignersGridNew>
        </FlexBox>
    );
};
import { FC, useState, useMemo } from 'react';
import { FlexBox } from '@brg/ui';
import { Designer, Lang, OpaUser } from '@brg/api';

import { IDesignerLight } from '../../../common';
import { DesignersGridNew } from '../../../components/grids';
import { NeutralLink } from 'shared/components/link/styles';
import { CreateLinkTo } from "../../../constants/linkTo";
import useQueryState from "../../../hooks/useQueryState";
import { DesignerCardNew } from 'shared/components/designerCard/designerCard';
import { computeDesigner } from 'shared/helpers/computeData';
import { CompetitionJuryCard } from '_competition/pages/CreateCompetitionPage/CompetitionJury';
import { ProfileUtils } from 'core';
import { getExpertTags } from 'shared/helpers/utils/TagsUtils';
import { CombinedEvents } from 'shared/helpers/projectEvents';

export interface TeachersTabProps {
    data: Designer[];
    isLoading?: boolean;
    showOpa?: boolean;
    showTags?: boolean;
    onDesignerClick?: (id: string) => void;
    isOpaCard?: boolean;
    pages?: number;
    noPagination?: boolean;
    inDetail?: boolean;
    language?: string;
    tooltip?: boolean;
    handlers?: CombinedEvents;
    isMe?: any;
    twoMobileColumns?: boolean;
    isMobileMoreVisible?: boolean;
}

const showAll = false;

/**
 * Грид с учителями
 * @param props
 * @constructor
 */
export const PeoplePageGrid: FC<TeachersTabProps> = (props) => {
    const { data, isLoading, showOpa, isOpaCard, inDetail, isMe, isMobileMoreVisible, twoMobileColumns, language, showTags , tooltip, ...handlers } = props;
    const [opaUsers] = useState<OpaUser[]>([]);

    const computeData: IDesignerLight[] = useMemo(
        () => data?.map((i) => computeDesigner(i)), [data])

        if (inDetail) {
            return (
                <FlexBox direction="column" directionMobile="column" gy={40} width="100%">
                    <DesignersGridNew isLoading={isLoading} mobileColumns={2} isOpaCard={isOpaCard} inDetailCard>
                        {data?.map((value) => {
                            const isExpert  = value?.rolesList?.includes("expertmoder");
                            const expertTags = isExpert ? getExpertTags(value?.tagsExpert) : [];
                            const showTags = isExpert && !!expertTags?.length;
                            return (
                                <CompetitionJuryCard 
                                    key={value?.designerId}
                                    avatar={ProfileUtils.getAvatarURLOrUndefined(value)}
                                    fullName={ProfileUtils.getFullNameString(value)}
                                    text={Lang(value?.about, language ?? 'ru')}
                                    tagsIds={expertTags}
                                    id={value?.designerId}
                                    href={CreateLinkTo.designerNew(value)}
                                    isShowcase
                                    showTags={showTags}
                                />
                            )
                        })}
                    </DesignersGridNew>
                </FlexBox>
            )
        }
    
    return (
        <FlexBox direction="column" directionMobile="column" gy={40} width="100%">
            <DesignersGridNew isLoading={isLoading} mobileColumns={2} isOpaCard={isOpaCard}>
                {computeData.map((value: IDesignerLight) => {
                    const opaUser = opaUsers.find((opaUser) => opaUser.accountId === value.identifier);

                    return (
                    //   <NeutralLink to={CreateLinkTo.designerNew(value)}>
                        
                    //@ts-ignore
                        <DesignerCardNew
                            showOpa={showOpa}
                            // onClick={onDesignerClick}
                            designer={value}
                            {...value}
                            {...handlers}
                            isMe={isMe}
                            isMobileMoreVisible={isMobileMoreVisible}
                            twoMobileColumns={twoMobileColumns}
                            key={value.identifier}
                            opaUser={opaUser}
                            isOpaCard={isOpaCard}
                            tooltip={tooltip}
                            withRating
                            href={CreateLinkTo.designerNew(value)}
                        />

                    );
                })}
            </DesignersGridNew>
        </FlexBox>
    );
};
